import * as React from "react"
import type { IconProps } from "../types"

const Flash = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", size = 24, ...props }, ref) => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        fill="none"
        ref={ref}
        viewBox="0 0 24 24"
        {...props}
      >
        <path
          stroke={color}
          strokeLinejoin="round"
          strokeWidth={2}
          d="M20 9H13V2L4 15H11V22L20 9Z"
        />
      </svg>
    )
  }
)
Flash.displayName = "Flash"

export default Flash
